/**
 * @generated SignedSource<<8faaaf5712d9d32289c6aad12885479f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateMessageDefinitionInput = {
  clientMutationId?: string | null;
  internalTitle: string;
};
export type createMessageDefinitionButton_CreateMessageDefinitionMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateMessageDefinitionInput;
};
export type createMessageDefinitionButton_CreateMessageDefinitionMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly createMessageDefinition: {
        readonly messageDefinition: {
          readonly node: {
            readonly createdAt: string;
            readonly id: string;
            readonly internalTitle: string;
            readonly showUntil: string | null;
          };
        };
      } | null;
    };
  };
};
export type createMessageDefinitionButton_CreateMessageDefinitionMutation = {
  response: createMessageDefinitionButton_CreateMessageDefinitionMutation$data;
  variables: createMessageDefinitionButton_CreateMessageDefinitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageDefinitionsEdge",
  "kind": "LinkedField",
  "name": "messageDefinition",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDefinition",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showUntil",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createMessageDefinitionButton_CreateMessageDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateMessageDefinitionPayload",
                "kind": "LinkedField",
                "name": "createMessageDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createMessageDefinitionButton_CreateMessageDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateMessageDefinitionPayload",
                "kind": "LinkedField",
                "name": "createMessageDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "messageDefinition",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6a63a758f732381efff4460be39c1f6",
    "id": null,
    "metadata": {},
    "name": "createMessageDefinitionButton_CreateMessageDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation createMessageDefinitionButton_CreateMessageDefinitionMutation(\n  $input: CreateMessageDefinitionInput!\n) {\n  Admin {\n    MessageDefinitions {\n      createMessageDefinition(input: $input) {\n        messageDefinition {\n          node {\n            id\n            internalTitle\n            createdAt\n            showUntil\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a63b27d7c08c43878d5656b56c8dcbb";

export default node;
